import { PHONE_REGEX, PASSWORD_REGEX } from '@/utils/regex.utils';
import { z } from 'zod';
import { userEntityRoleSchema } from '../user-entity-role/user-entity-role.schema';
import i18next from 'i18next';

export const userSchema = z.object({
  id: z.string().optional(),
  title: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:titleRequired'),
      });
    }
  }),
  lastname: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:lastnameRequired'),
      });
    }
  }),
  firstname: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:firstnameRequired'),
      });
    }
  }),
  phone: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:phoneNumberRequired'),
      });
    } else if (!PHONE_REGEX.test(data)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:phoneNumberIncorrect'),
      });
    }
  }),
  email: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:emailRequired'),
      });
    } else if (!z.string().email().safeParse(data).success) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:emailFormatIncorrect'),
      });
    }
  }),
  password: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:passwordRequired'),
      });
    } else if (!PASSWORD_REGEX.test(data)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:passwordFormatIncorrect'),
      });
    }
  }),
  profilePicture: z.string().nullish(),
  active: z.boolean().default(true),
  entityRoles: z.array(userEntityRoleSchema).nullish(),
  createdBy: z.string().nullish(),
});

export type TUserSchema = z.infer<typeof userSchema>;
